<div class="dropdown-container" (mouseleave)="showDropDown = false">
    <!-- Search box with badges -->
    <div class="search-box position-relative" (click)="toggleDropdown()">
        <div class="badges-container">
            <div class="search-box-wrapper">
                <input type="text" [(ngModel)]="searchTerm" (input)="filterDropdown()" [placeholder]="field.placeholder"
                    [maxlength]="field.maxLength" class="form-control search-input" />
                <img src="../../../assets/images/search_icon.svg" alt="Search Icon" class="search-icon" />
            </div>
        </div>
    </div>

    <!-- Dropdown list -->
     @if(showDropDown){
    <div class="drop-show">
        @if(filteredDropdownList.length > 0){
        <div >
            @for(item of filteredDropdownList;track item){
            <div  class="dropdown-item" style="cursor: pointer;"
                (click)="selectItem(item, field.name); $event.stopPropagation()">
                <input type="checkbox" [checked]="isSelected(item)" />
                {{ item?.name }}
            </div>
        }
        </div>
    }
    @if(filteredDropdownList.length == 0){
        <div  style="text-align: center;">
            No Records Found
        </div>
    }
    </div>
}
    @for(item of selectedItems.slice(0, 2);track item){
    <ng-container >
        <span class="badge">
            {{ item.name }}
            <span class="close-icon" (click)="removeItem(item, field.name); $event.stopPropagation()">✕</span>
        </span>
    </ng-container>
}
    @if(selectedItems.length > 2){
    <span  style="cursor: pointer;" class="badge count-badge"
        (click)="toggleDropdown()">
        +{{ selectedItems.length - 2 }}
    </span>
}
</div>